var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUser = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 6.375C9 4.51104 10.511 3 12.375 3C14.239 3 15.75 4.51104 15.75 6.375C15.75 8.23896 14.239 9.75 12.375 9.75C10.511 9.75 9 8.23896 9 6.375ZM12.375 1.5C9.68261 1.5 7.5 3.68261 7.5 6.375C7.5 9.06739 9.68261 11.25 12.375 11.25C15.0674 11.25 17.25 9.06739 17.25 6.375C17.25 3.68261 15.0674 1.5 12.375 1.5ZM9 12.75C7.72548 12.75 5.06467 13.426 4.24835 14.5145C3.43513 15.5988 3 17.034 3 18.5V19.5C3 20.7426 4.00736 21.75 5.25 21.75H18.75C19.9926 21.75 21 20.7426 21 19.5V18.5C21 17.034 20.5649 15.5988 19.7517 14.5145C18.9353 13.426 16.2745 12.75 15 12.75H9ZM5.44835 15.4145C6.03856 14.6275 8.2854 14.25 9 14.25H15C15.7146 14.25 17.9614 14.6275 18.5517 15.4145C19.145 16.2055 19.5 17.3139 19.5 18.5V19.5C19.5 19.9142 19.1642 20.25 18.75 20.25H5.25C4.83579 20.25 4.5 19.9142 4.5 19.5V18.5C4.5 17.3139 4.85505 16.2055 5.44835 15.4145Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user.d75e0887e056a0a85c65049bae2b8907.svg";